import React from "react";
import parse from 'html-react-parser';
import { Container } from "react-bootstrap";
import useAboutUs from "hooks/useAboutUs";

const AboutUsSection = () => {
  const { aboutData } = useAboutUs();

  return (
    <section className="terms-page">
      <Container>
        {parse(aboutData?.description || "")}
      </Container>
    </section>
  );
};

export default AboutUsSection;